/** Save-time persistence orchestration (spec §2.1). Fail-closed ordering:
 *  1) ExecQuotePricing record  2) per-line persist events  3) caller's
 *  createQuote (with the returned outputs). quoteId is client-generated
 *  before any write, so failures leave only harmless orphans. */
import { hasOverrides } from '../domain/PricingOverrides';
import { buildExecQuotePricingRecord, writeExecQuotePricing } from './execQuotePricing';
import { buildPersistEvents, recordPersistEvents } from './execPricingAudit';

export async function persistCustomPricing({
  quoteId, execPricing, config, productDb, bom, actor, vendorId, appVersion, savedAt,
}) {
  if (!hasOverrides(execPricing.overrides)) return { ok: true, customPricing: null };

  const record = buildExecQuotePricingRecord({ quoteId, execPricing, actor, appVersion, savedAt });
  if (!(await writeExecQuotePricing(record))) return { ok: false, customPricing: null };

  const events = buildPersistEvents('quoteSave', {
    execPricing, config, productDb, bom, quoteSerial: quoteId, actor, vendorId, appVersion,
  });
  if (!(await recordPersistEvents(events))) return { ok: false, customPricing: null };

  return {
    ok: true,
    customPricing: {
      overrideSetId: execPricing.overrideSetId,
      vendor: execPricing.snapshot.vendor,
      quarter: execPricing.snapshot.quarter,
      customPrices: JSON.stringify(execPricing.customPrices),
      customSkus: [...execPricing.customSkus],
      savedAt,
    },
  };
}
